package com.schoolconnect.app.repository.quickannouncement

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.request.QuickAnnouncementCreateRequest
import com.schoolconnect.app.datasource.network.request.QuickAnnouncementUpdateRequest
import com.schoolconnect.app.datasource.network.response.QuickAnnouncementListResponse
import com.schoolconnect.app.datasource.network.response.QuickAnnouncementResponse
import com.schoolconnect.app.util.scLog
import com.schoolconnect.app.repository.common.RepositoryCache
import com.schoolconnect.app.repository.common.tenantCacheKey
import kotlinx.coroutines.CoroutineScope

object QuickAnnouncementRepository {
    private const val TAG = "[DATA_RETRIEVE_SC] QuickAnnouncementRepository"
    private val pageCache = RepositoryCache<QuickAnnouncementListResponse>()

    suspend fun loadPage(search: String?, status: String?, createdById: String?, period: String?, pageIndex: Int, pageSize: Int, sortBy: String?, ascending: Boolean, refreshScope: CoroutineScope): Result<QuickAnnouncementListResponse> {
        val safeSize = pageSize.coerceIn(1, 100)
        val offset = pageIndex.coerceAtLeast(0) * safeSize
        val normalizedSort = sortBy?.trim().orEmpty()
        val key = tenantCacheKey("quick-announcements:${search.orEmpty()}:${status.orEmpty()}:${createdById.orEmpty()}:${period.orEmpty()}:$normalizedSort:$ascending:$offset:$safeSize")
        return pageCache.load(refreshScope, TAG, "loadPage", key) { KtorApiClient.getQuickAnnouncements(search = search, status = status, createdById = createdById, period = period, limit = safeSize, offset = offset, sortBy = normalizedSort, order = if (ascending) "asc" else "desc")
            .onFailure { scLog("$TAG loadPage failure offset=$offset limit=$safeSize", it) } }
    }

    suspend fun create(request: QuickAnnouncementCreateRequest): Result<QuickAnnouncementResponse> =
        KtorApiClient.createQuickAnnouncement(request).onSuccess { pageCache.clear() }.onFailure { scLog("$TAG create failure", it) }

    suspend fun update(id: String, request: QuickAnnouncementUpdateRequest): Result<QuickAnnouncementResponse> =
        KtorApiClient.updateQuickAnnouncement(id, request).onSuccess { pageCache.clear() }.onFailure { scLog("$TAG update failure id=${id.trim()}", it) }

    suspend fun duplicate(id: String): Result<QuickAnnouncementResponse> =
        KtorApiClient.duplicateQuickAnnouncement(id)
            .onSuccess { pageCache.clear() }
            .onFailure { scLog("$TAG duplicate failure id=${id.trim()}", it) }

    suspend fun endNow(id: String): Result<kotlinx.serialization.json.JsonObject> =
        KtorApiClient.endQuickAnnouncement(id)
            .onSuccess { pageCache.clear() }
            .onFailure { scLog("$TAG end now failure id=${id.trim()}", it) }

    suspend fun delete(id: String): Result<kotlinx.serialization.json.JsonObject> =
        KtorApiClient.deleteQuickAnnouncement(id)
            .onSuccess { pageCache.clear() }
            .onFailure { scLog("$TAG delete failure id=${id.trim()}", it) }
}
